import type { MinimalState } from '../ui/studyDetailsTab/editStudyDetails/editDiagnosisDrawer/editDiagnosisDrawer.types';

const initalState: MinimalState = {
  // UI fields
  primary: undefined,
  second: undefined,
  patientMedications: '',

  // Diagnosis select state
  searchPrimary: '',
  diagnosisCodesPrimary: [],
  isLoadingPrimary: false,

  searchSecond: '',
  diagnosisCodesSecond: [],
  isLoadingSecond: false,

  // Modals + saving
  isOpenConfirmModal: false,
  isSaving: false,

  // Errors
  listError: {},

  // init loading
  isInitiating: false,
};

export { initalState };
